// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1y798","label":"Labeled_label__RgRXe","divider":"Labeled_divider__-5PSI"};